import * as React from 'react'
import { MessageSquare } from 'react-feather'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import ContactSchoolModal from 'main/components/lead/ContactSchoolModal'
import { NAV_MODALS } from 'main/hooks/useSSOContext'
import { palette } from 'main/ui'

import CTAButton from '../common/CTAButton'
import useNavContextModal from '../common/useNavContextModal'

interface IProps extends RouteComponentProps {
  tourDisabled: boolean
  full: boolean
  label: string
  schoolId: number
}

function MessageDirector(props: IProps) {
  const { tourDisabled, full, label, schoolId, location } = props

  const [isModalOpen, openModal, closeModal] = useNavContextModal(
    NAV_MODALS.MESSAGE_DIRECTOR,
    location.pathname,
  )

  return (
    <>
      <CTAButton
        full={full}
        icon={<MessageSquare color={tourDisabled ? palette.white : palette.skyBlue2} />}
        kind={tourDisabled ? 'regular' : 'outline'}
        label={label}
        pendo="school-page-contact-school-button"
        onClick={() => openModal()}
      />
      {isModalOpen && (
        <ContactSchoolModal schoolId={schoolId} onRequestClose={() => closeModal()} />
      )}
    </>
  )
}

export default withRouter(MessageDirector)
